import { Drawer as AntDrawer, Button } from 'antd';
import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import useScreenType from '../../hooks/utility/useScreenType';

export default function Drawer({ title, hideCloseIcon, onClose, children, ...rest }) {
  const { isMobile } = useScreenType();

  return (
    <AntDrawer
      title={null}
      size={isMobile ? '100%' : '50%'}
      styles={{
        header: { display: 'none' },
        body: {
          padding: 0,
          position: 'relative',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
      onClose={onClose}
      {...rest}
    >
      {(Boolean(title) || !hideCloseIcon) && (
        <div className="relative border-b bg-gray-50 border-gray-200 py-md">
          <h6 className="w-full text-center">{title}</h6>
          {!hideCloseIcon && (
            <Button
              type="text"
              className={classnames('absolute top-1/2 -translate-y-1/2 text-lg', {
                'right-md': isMobile,
                'left-md': !isMobile,
              })}
              icon={<CloseOutlined />}
              onClick={onClose}
            />
          )}
        </div>
      )}
      {children}
    </AntDrawer>
  );
}
